import { Avatar, Button, ButtonProps, CircularProgress, Typography } from "@mui/material"
import { DamsColors } from "../styles/DamsColors"
import { grey } from "@mui/material/colors"

export type CustomBtnProps = {
    btnIconSrc?: string
    iconPosition?: 'left' | 'right',
    height?: number,
    width?: number | 'auto',
    loading?: boolean,
    iconAnchorLoading?: boolean
} & ButtonProps

function ButtonBase({
    title = 'Btn Title',
    btnIconSrc = '',
    iconPosition = 'left',
    height = 40,
    width = 'auto',
    sx,
    onClick,
    variant,
    loading,
    iconAnchorLoading

}: CustomBtnProps) {
    const IconComponent = (
        btnIconSrc !== '' &&
        <Avatar
            src={btnIconSrc}
            alt="btn Icon"
            sx={styles.btnIcon}
            variant="square" />
    )

    const btnStyles = {
        width: typeof width === 'number' ? `${width}px` : width,
        height: `${height}px`,

        ...(variant === 'contained' && styles.containedBtn),
        ...(variant === 'outlined' && styles.outlinedBtn),
        ...(variant === 'text' && styles.textBtn)
    }

    const fontColor = (variant: string | undefined) => {
        if (variant === 'contained') return DamsColors.Text.WhiteText;
        if (variant === 'outlined') return DamsColors.Text.PrimaryText;
        if (variant === 'text') return DamsColors.Text.Highlight;
        return ''
    }
 
    const renderLeftIcon= iconAnchorLoading ? <CircularProgress size={15} sx={{color:grey[500]}} />: IconComponent
    
    return (
        <Button
            sx={{ ...styles.btnContainer, ...btnStyles, ...sx }}
            startIcon={
                !loading && iconPosition === 'left' && (renderLeftIcon)
            }
            endIcon={
                !loading && iconPosition === 'right' && (IconComponent)
            }
            onClick={onClick}
            variant={variant}
            // disabled={loading}
        >
            {loading ? (
                <CircularProgress size={24} sx={styles.spinner} />
            ) : (
                <Typography
                    fontFamily={'Inter'}
                    fontWeight={600}
                    fontSize={14}
                    color={fontColor(variant)}
                    noWrap
                    sx={styles.btnText}
                >
                    {title}
                </Typography>
            )}
        </Button>
    )
}


const styles = {
    btnContainer: {
        // border: '1pc solid blue',
        // gap: 1
        borderRadius: '8px'
    },

    btnIcon: {
        width: '20px',
        height: '20px',
    },

    btnText: {
        textTransform: 'none'
    },

    outlinedBtn: {
        border: `1px solid ${DamsColors.Border.FooterDivider}`,

        '&:hover': {
            backgroundColor: DamsColors.SideBar.SideBarContainer,
            border: `1px solid ${DamsColors.Border.FooterDivider}`
        }
    },

    textBtn: {
        backgroundColor: DamsColors.Button.Text,
    },

    containedBtn: {
        backgroundColor: DamsColors.Button.Primary,

        '&:hover': {
            backgroundColor: DamsColors.Button.Primary,
        }

    },

    spinner: {
        color: grey[300],
    }
}


export { ButtonBase }
